import { createSelector } from 'reselect';

export const getSingleContactFetching = state => state?.contacts?.singleFetching;

export const getContactData = (state, iri) => state.contacts?.[iri];

export default createSelector([getSingleContactFetching, getContactData]);
